import React from 'react';
import PropTypes from 'prop-types';

const Title = ({ actionType }) => {
  switch (actionType) {
  case 'deactivate':
    return <h4 className="text-center mt-0">Are you sure that you want to deactivate integration?</h4>;

  default:
    return null;
  }
};

Title.propTypes = {
  actionType: PropTypes.string,
};

export default Title;
